import React from "react"
import type {SearchScheme} from "@/types/SearchScheme"

interface SchemeButtonProps {
   scheme: SearchScheme
   selected: boolean
   onPress: (scheme: SearchScheme) => void
}

const labels: Record<SearchScheme, string> = {
   sale: "Venta",
   rent: "Renta",
}

export default function SchemeButton({scheme, selected, onPress}: SchemeButtonProps) {
   return (
      <button
         type="button"
         aria-pressed={selected}
         onClick={() => onPress(scheme)}
         className={`rounded-md border px-3 py-1 text-sm font-medium transition-colors ${
            selected
               ? "border-blue bg-blue text-white"
               : "border-blue text-blue hover:bg-blue/10"
         }`}
      >
         {labels[scheme]}
      </button>
   )
}
